import CacheDataInterface from "@app/Interface/CacheDataInterface";

export default class CacheDataModel implements CacheDataInterface {
    url: string;
    content: string;
    date: Date;
    staleDate: Date | null;

    /**
     * 
     * @param url        URL of request
     * @param content    string content
     * @param staleAfter Optiona: Number of minutes before cache becomes stale 
     */
    constructor(url: string, content: string, staleAfter?: number) {

        const currentDate = new Date();

        this.url = url ?? "";
        this.content = content ?? null;
        this.date = currentDate;
        this.staleDate = null;

        if (staleAfter || staleAfter === 0) {

            const staleDate = new Date();

            staleDate.setMinutes(staleDate.getMinutes() + staleAfter);

            this.staleDate = staleDate;

        }

    }

}
